import { PERMISSIONS } from "../../components/admin/SchoolAdmin/config/permissions";
import { useTenantAuth } from "../../context/TeanantAuthProvider";



export const usePermission = () => {
  const { currentUser } = useTenantAuth();
  const role = currentUser?.role_slug;

  const can = (permission) => {
    const allowedRoles = PERMISSIONS[permission];

    if (!allowedRoles) {
      console.warn(`Permission "${permission}" not defined`);
      return false;
    }

    return allowedRoles.includes(role);
  };

  return { can, role };
};
